import { render, staticRenderFns } from "./BranchListTable.vue?vue&type=template&id=35897c2e&scoped=true"
import script from "./BranchListTable.vue?vue&type=script&lang=ts"
export * from "./BranchListTable.vue?vue&type=script&lang=ts"
import style0 from "./BranchListTable.vue?vue&type=style&index=0&id=35897c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35897c2e",
  null
  
)

export default component.exports